import React from 'react';

const Icon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 130 93"
		{...props}
	>
		<path
			fill="#E5E7F9"
			d="M122.763 50.927v-.008l-.098-.053a4.73 4.73 0 0 0-.324-.177L68.246 21.213c-.2-.123-.406-.233-.61-.344-.033-.016-.062-.033-.095-.05a9.457 9.457 0 0 0-1.254-.532 2.104 2.104 0 0 1-.152-.053 12.468 12.468 0 0 0-.557-.168c-.033-.008-.07-.02-.103-.029a10.615 10.615 0 0 0-.623-.14l-.22-.036a6.666 6.666 0 0 0-.5-.07 11.997 11.997 0 0 0-.717-.061h-.087a6.696 6.696 0 0 0-.406 0h-.492c-.18.008-.36.024-.54.04-.058.005-.12.017-.177.021-.168.02-.336.045-.5.07l-.221.037c-.21.04-.418.086-.623.14-.033.007-.07.02-.103.028a8.298 8.298 0 0 0-.557.168 10.027 10.027 0 0 0-1.406.586c-.033.016-.061.033-.094.05a8.062 8.062 0 0 0-.61.343L3.506 50.69c-.11.058-.222.115-.324.177l-.098.053v.008a5.403 5.403 0 0 0-2.566 4.595 5.403 5.403 0 0 0 2.566 4.594v.008l.098.053c.107.062.213.123.324.177L57.716 89.9c.18.107.365.21.553.304.02.008.037.02.058.028.38.193.778.365 1.184.509l.07.024c.176.062.352.115.529.168.04.012.077.025.118.033.402.11.816.197 1.238.258.053.008.107.012.156.02.16.021.32.038.483.05l.18.012c.21.012.423.02.64.02.217 0 .426-.008.64-.02.061 0 .118-.008.18-.012.164-.013.324-.029.483-.05.054-.008.107-.012.156-.02.422-.061.836-.147 1.238-.258.04-.012.078-.02.119-.033.18-.05.356-.106.528-.168l.07-.024c.406-.144.803-.316 1.185-.509.02-.008.036-.02.057-.028a8.94 8.94 0 0 0 .553-.304l54.21-29.545a7.57 7.57 0 0 0 .324-.177l.099-.053v-.008a5.402 5.402 0 0 0 2.565-4.594 5.402 5.402 0 0 0-2.565-4.595h-.005Z"
		/>
		<rect
			width="34"
			height="29.5"
			x="9.833"
			y="18.776"
			fill="#fff"
			stroke="#000"
			rx="5.5"
		/>
		<rect
			width="34"
			height="29.5"
			x="29.833"
			y="28.776"
			fill="#fff"
			stroke="#000"
			rx="5.5"
		/>
		<rect
			width="34"
			height="29.5"
			x="49.833"
			y="38.776"
			fill="#fff"
			stroke="#000"
			rx="5.5"
		/>
		<rect
			width="34"
			height="29.5"
			x="69.833"
			y="48.776"
			fill="#fff"
			stroke="#000"
			rx="5.5"
		/>
		<path
			fill="#7BF35D"
			d="M85.725 53.758c-2.977.413-5.354 2.467-4.462 4.495.496 1.23 1.69 1.632 3.412.507s3.878-.672 4.351.462c.474 1.134-.63 1.954-1.566 2.453-.936.499-2.735 1.379-3.05 3.25-.317 1.873.88 4.517 3.249 3.617 2.37-.9 1.086-1.776 1.697-3.464.612-1.687 5.274-2.419 4.497-6.707-.776-4.288-5.151-5.027-8.128-4.614Zm-.85 19.277c-.733-1.468.245-2.704 1.46-3.136 1.246-.47 2.874.105 3.403 1.479.529 1.374-.023 2.44-1.434 3.029-1.41.588-2.697.096-3.43-1.372Z"
		/>
		<path
			fill="#000"
			d="m27.01 74.588-1.25 1.5-.437 1.25.438 2.875 2.937 1 3.188-1.875 18-21.875-1.938-2.063-20.937 19.188Z"
		/>
		<path
			stroke="#000"
			d="M48.042 55.432 26.245 75.46a3.322 3.322 0 1 0 4.788 4.587L50.117 57.4"
		/>
		<g style={{ mixBlendMode: 'multiply' }}>
			<circle
				cx="66.797"
				cy="38.674"
				r="25.125"
				fill="url(#a)"
				fillOpacity=".2"
			/>
			<circle cx="66.797" cy="38.674" r="25.125" stroke="#000" />
		</g>
		<path
			stroke="#000"
			strokeLinecap="round"
			d="M14.886 23.713H30.76m4.376 9.813H52.01m3 10h15.876m12.446-18.972a21.657 21.657 0 0 1 5.208 14.12c0 5.19-1.817 9.953-4.85 13.691"
		/>
		<path
			fill="#6221F2"
			d="M42.111 1.287c-1.988.782-3.287 2.598-2.332 3.85.548.767 1.44.845 2.442-.22 1.001-1.063 2.567-1.11 3.083-.406.517.704-.11 1.455-.673 1.956-.563.501-1.659 1.409-1.565 2.755.094 1.346 1.362 2.974 2.848 1.956 1.487-1.017.454-1.408.595-2.676.141-1.268 3.24-2.551 1.988-5.384C47.245.285 44.099.504 42.11 1.287Zm2.629 13.46c-.75-.892-.281-1.91.486-2.41.782-.533 2.003-.407 2.598.454.595.86.391 1.69-.485 2.332-.877.641-1.847.516-2.598-.376Z"
		/>
		<path
			fill="#fff"
			d="M60.188 74.524c-2.5-.374-4.908.718-4.67 2.567.108 1.11.976 1.719 2.633 1.22 1.657-.498 3.29.38 3.402 1.409.113 1.028-.973 1.427-1.848 1.607-.874.18-2.535.462-3.235 1.898-.7 1.436-.364 3.855 1.762 3.692 2.127-.163 1.3-1.175 2.194-2.392.895-1.216 4.833-.698 5.226-4.344.393-3.645-2.962-5.283-5.464-5.657Zm-5.272 15.357c-.242-1.36.842-2.124 1.925-2.184 1.117-.082 2.295.769 2.395 2.003.1 1.235-.6 1.965-1.878 2.104-1.279.14-2.2-.564-2.442-1.923Z"
		/>
		<defs>
			<linearGradient
				id="a"
				x1="50.48"
				x2="78.021"
				y1="56.793"
				y2="16.207"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D1FAFF" />
				<stop offset="1" stopColor="#D1FAFF" stopOpacity="0" />
			</linearGradient>
		</defs>
	</svg>
);

export default Icon;
